


























import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import GenericBTable from "@/core/Generics/GenericBTable";
import BTableColumn from "@/models/base/BTableColumn.model";
import Language from "@/models/language/language.model";
import { BTableColumnType } from "@/enums/BTableColumnType";
import i18n from "@/Plugin/i18n.ts";
import { PermissionValue } from "@/enums/PermissionValue";
import UserResearchCenter from "@/models/security/userResearchCenter.Model";
import UserBasicInformationComponent from "@/components/user-basic-information/userBasicInformation.vue";
import ResearchCenterBasicInformationComponent from "@/components/research-center-basic-information/researchCenterBasicInformation.vue";
import User from "../../models/security/user.model";
import BaseSelectPerson from "@/components/base/baseSelectPerson/baseSelectPerson.vue";
import BaseSelectResearchCenter from "@/components/base/baseSelectResearchCenter/baseSelectResearchCenter.vue";
import AnnoucementService from '@/services/researchCenter.service';

@Component({
  components: {
    UserBasicInformationComponent,
    ResearchCenterBasicInformationComponent,
    BaseSelectResearchCenter,
    BaseSelectPerson
  }
})
export default class FacultyTable extends GenericBTable<UserResearchCenter> {
  isLoading = false;
  facultyRepository: AnnoucementService = new AnnoucementService();
  name = "";
  researchCenterId = null;
  userId = null;
  @Prop() public currentResearchCenterId!: number;

  created() {
    this.tableConfig.controller =
      "Faculty/GetByResearchCenterId/" + this.currentResearchCenterId;
    this.formatColumns();
  }

  formatColumns() {
    let user = new BTableColumn("name", "table.name", true);
    let researchCenter = new BTableColumn(
      "description",
      "table.description",
      true
    );
    //user.customTemplate = true;
    //researchCenter.customTemplate = true;
    researchCenter.width = "60%";
    this.tableConfig.enableDefaultColumns = false;
    this.tableConfig.insertColumns(user, researchCenter);
    this.tableConfig.actions.customTemplate = true;
  }

  // @Watch("researchCenterId")
  // getResultResearch() {
  //   this.tableConfig.whereParams = `researchCenterId eq ${this.researchCenterId}`;
  //   this.tableConfig.reload();
  // }

  // @Watch("userId")
  // getResultUser() {
  //   this.tableConfig.whereParams = `userId eq ${this.userId}`;
  //   this.tableConfig.reload();
  // }

  removeRecord(id: number) {
    this.$buefy.dialog.confirm({
      title: "Confirmación",
      message: "¿Desea eliminar este registro?",
      confirmText: "Adelante!",
      cancelText: "Cancelar",
      type: "is-danger",
      size: "is-medium",
      hasIcon: true,
      onConfirm: () => this.confirmRemove(id)
    });
  }

  protected async confirmRemove(id: number) {
    try {
      await this.facultyRepository.deleteFaculty(id);
      this.operationSuccess("Registro eliminado!");
      if (this.tableConfig.reload) this.tableConfig.reload();
    } catch (e) {
      this.operationFailed(e);
    }
  }

  editRecord(id: number) {
    this.$router.push(`/faculties/${this.currentResearchCenterId}/editar/${id}`);
  }
}
